export const Post18534 = () => {
    return(
        <div class="w-full text-left">
            <div className="w-full min-h-[400px] md:min-h-[500px] rounded-xl" style={{background: `url(/blog-photos/infy-blog-value.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            <p className="mt-4">State of California, Department of Industrial Relations, Division of Workers’ Compensation, 24th Annual Education Conference.</p>
            <p className="mt-4">
            <strong>Dates: &nbsp;</strong>
            </p>
            <p className="mt-4">
            <strong>February 23-24, 2017, Los Angeles, California &amp;</strong>
            </p>
            <p className="mt-4">
            <strong>March 2-3, 2017, Oakland, California&nbsp;</strong>
            </p>
            <p className="mt-4">Title of Presentation:&nbsp;“The Value of Artificial Intelligence and Advanced Analytics in Identifying and Reducing Workers’ Compensation Fraud.”</p>
            <div className="text-center mt-8">
                <a className="m-auto bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" href="/blog-photos/2017-DWC-WC-Conference-Presentation.pdf" target="_blank">
                Download Article
                </a>
            </div>
            
        </div>
        
    )
}